module.exports = __webpack_public_path__ + "static/media/user-20.ccd5b4fe.png";